import { useQuery } from '@tanstack/react-query'
import type { FaqItem } from '../api/faqApi'
import { fetchFaqItems } from '../api/faqApi'
import { DEFAULT_FAQ_ITEMS } from '../constants/defaultFaq'

export const useFaq = () => {
  return useQuery<FaqItem[]>({
    queryKey: ['faq'],
    queryFn: async () => await fetchFaqItems(),
    staleTime: 1000 * 60 * 10, // Cache for 10 minutes
    retry: 2,
    placeholderData: DEFAULT_FAQ_ITEMS, // Show default content while loading
  })
}
